/**
 * Public Beatly legal pages. These URLs are intentionally kept in one place so
 * the product never falls back to a placeholder link for required legal copy.
 */
export const BEATLY_PRIVACY_POLICY_URL = 'https://www.beatly.com/info/privacy-policy';
export const BEATLY_TERMS_OF_SERVICE_URL = 'https://www.beatly.com/info/terms-of-service';
